import { ButtonRules } from '@canopysecurity/component-library';
import { Borderline } from '../../StyledComponents/Borderline';
import { ActionButton, ButtonContainer } from '../../StyledComponents/Buttons';
import { BackgroundContainer } from '../../StyledComponents/PageContainer';
import { ModalTitleText } from '../../StyledComponents/Typography';
import { StatusMessage } from '../StatusMessage';
export interface ModalContentProps {
  title: string;
  loading: boolean;
  error?: { message: string } | null;
  handleSubmit: () => void;
  submitDisabled: boolean;
  handleClose: () => void;
  buttonLabels: {
    loading: string;
    create: string;
  };
  children?: React.ReactNode;
}
export const ModalContent = ({
  title,
  loading,
  error,
  handleSubmit,
  submitDisabled,
  handleClose,
  buttonLabels,
  children,
}: React.PropsWithChildren<ModalContentProps>) => {
  return (
    <div>
      <div role="dialog" aria-labelledby="create-tag-title">
        <ModalTitleText id="modal-title">{title}</ModalTitleText>
      </div>
      <Borderline />
      {children}

      <Borderline />
      {error && (
        <>
          {console.log('error', error)}
          <StatusMessage isError={true} text={error.message} /> <Borderline />
        </>
      )}
      <BackgroundContainer>
        <ButtonContainer>
          <ActionButton
            disabled={loading}
            onPress={handleClose}
            buttonRules={ButtonRules.secondary}
          >
            Cancel
          </ActionButton>
          <ActionButton
            disabled={submitDisabled}
            onPress={handleSubmit}
            buttonRules={ButtonRules.primaryA}
          >
            {loading ? buttonLabels.loading : buttonLabels.create}
          </ActionButton>
        </ButtonContainer>
      </BackgroundContainer>
    </div>
  );
};
